import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Quote from "@/pages/Quote";
import QuotationResult from "@/pages/QuotationResult";
import ClientDashboard from "@/pages/ClientDashboard";
import ClientProjectDetail from "@/pages/ClientProjectDetail";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/quote/:categoryId" element={<Quote />} />
          <Route path="/quotation/:quoteId" element={
            <ProtectedRoute><QuotationResult /></ProtectedRoute>} />
          <Route path="/project/:projectId" element={
            <ProtectedRoute><ClientProjectDetail /></ProtectedRoute>} />
          <Route path="/dashboard/*" element={
            <ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
          <Route path="/admin/*" element={
            <ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-center" richColors theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
